<!--
 * @Description: 
 * @Date: 2020-09-22 16:58:46
-->
<template>
  <div class="record">
    <div class="record-title">
      <span>历史记录</span>
      <van-icon name="delete" @click.native="searchClearn" />
    </div>
    <ul class="record-ul">
      <li
        class="record-ul-li text-overflow-1"
        v-for="(item,index) in (historyList||[]).slice(0,5)"
        :key="index"
        @click="handleClick(item)"
      >{{item}}</li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  data() {
    return {
      hotSearchList: null
    };
  },
  computed: {
    ...mapState({
      historyList: state => state.search.historyList
    })
  },
  methods: {
    ...mapActions(['searchWordActions', 'searchClearn']),
    handleClick(item) {
      let keyword = typeof item === 'object' ? item.hotword : item
      this.searchWordActions(keyword);
      this.$emit('search-input-enter', keyword);
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
@import '~@/style/mixins.less';
.record {
  padding: 0 0.43rem;

  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 0.43rem;
    }
    i {
      font-size: 0.48rem;
      color: #3667ec;
    }
  }
  &-ul {
    padding: 0.11rem 0;
    display: flex;
    flex-wrap: wrap;
    margin-left: -0.16rem;
    &-li {
      margin: 0.16rem;
      background: #f6f6fa;
      border-radius: 0.11rem;
      padding: 0.24rem 0.27rem;
      max-width: 4.27rem;
    }
  }
}
</style>
